import { SEARCH_MODE } from "@src/constants";

import { OpenShiftItemBookingStatus } from "../store/shift/model";

export const HCP_ACTIONS = {
  TIME_SLOT_CLICK: "TIME_SLOT_CLICK",
  MARK_INTEREST: "MARK_INTEREST",
  SELF_CLAIM: "SELF_CLAIM",
};

export const MISSING_DOCS_TRIGGER = {
  MISSING_DOCUMENTS: "MISSING_DOCUMENTS",
  BOOKING_ATTEMPT: "BOOKING_ATTEMPT",
};

export interface ISharedShiftSlot {
  sharedShiftStart: string;
  sharedShiftEnd: string;
  sharedShiftName: string;
  sharedFacilityId: string;
}

export const TIME_FORMAT = "h:mm a";

export const ShiftItemInitialBookingStatus = {
  [SEARCH_MODE.NON_QFA_RANGE_SHIFTS]:
    OpenShiftItemBookingStatus.NON_QFA_RANGE_SHIFT_CHECK_DOCUMENT_STATUS,
};

export enum NonQfaShiftItemLabels {
  CHECK_DOCUMENT_STATUS = "Check if I can book",
  CHECKING_DOCUMENT_STATUS = "Checking requirements...",
  DOCUMENT_STATUS_CHECK_PASS = "Book This Shift",
  DOCUMENT_STATUS_CHECK_FAIL = "Upload missing requirements",
}
